import styled from "@emotion/styled";
import {
  grayScale,
  mCaption1,
  wCaption1,
  wHeader2,
  mHeader1,
  mTitle3,
  wHeader1,
  wTitle3,
  wBody3,
  wBody4,
  sparta,
} from "@teamsparta/design-system";
import { forDesktop } from "@/themes/device";

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  width: 328px;
  margin: 0 auto;
  ${forDesktop} {
    width: 796px;
    align-items: center;
  }
`;

export const Article = styled.article`
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
  &:last-child {
    margin-bottom: 0;
  }
  ${forDesktop} {
    align-items: center;
    margin-bottom: 80px;
  }
`;

export const Title = styled.span`
  ${mHeader1};
  ${forDesktop} {
    ${wHeader2};
    text-align: center;
  }
`;

export const H2 = styled.div`
  margin: 32px 0 4px;
  ${mHeader1};
  ${forDesktop} {
    ${wHeader1};
    margin: 40px 0 10px;
  }
`;

export const P = styled.div`
  ${mTitle3};
  color: ${grayScale.gray80} !important;
  ${forDesktop} {
    ${wTitle3};
  }
`;

export const Curriculums = styled.div`
  margin-top: 50px;
  ${forDesktop} {
    margin-top: 80px;
  }
`;

export const Curriculum = styled.div`
  margin: 0 0 60px 0;
  &:last-child {
    margin: 0;
  }
`;

export const Info = styled.small`
  ${mCaption1};
  font-weight: 500;
  color: ${grayScale.gray70};
  text-align: center;

  ${forDesktop} {
    ${wCaption1};
    font-weight: 500;
    color: ${grayScale.gray70};
  }
`;

export const CurriculumABTUpdate = styled.div`
  background-color: ${grayScale.gray10};
  border: 1px solid ${grayScale.gray30};
  border-radius: 8px;
  margin-top: 30px;
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  span {
    :nth-of-type(1) {
      position: relative;
      ${wBody3};
      span {
        position: absolute;
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background-color: ${sparta.red100};
      }
    }
    :nth-of-type(2) {
      ${wBody4};
      white-space: pre-wrap;
      color: ${grayScale.gray90} !important;
    }
    :nth-of-type(3) {
      ${wBody4};
      color: ${grayScale.gray70} !important;
    }
  }
  ${forDesktop} {
    flex-direction: row;
    gap: 0;
    justify-content: space-between;
    span {
      :nth-of-type(2) {
        white-space: nowrap;
        width: 433px;
      }
    }
  }
`;
